import { EmptyStateProductNotFound } from '../../Common/EmptyStates';

export default function NotFound() {
  return (
    <section className="section-main section-full not-found-page">
      <div className="container">
        <EmptyStateProductNotFound />
      </div>
    </section>
  );
}
